// extracted by mini-css-extract-plugin
export var phone = "_2n-0";
export var phoneDragging = "_2n-1";